import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLazyQuery } from 'react-apollo'

import { useRestaurant } from '../../RestaurantProvider/RestaurantProvider'

import { MENU_ITEM_DETAILS } from '../../../apollo/menu/menuitem.graphql'
import { useAddItemToCart } from '../../CartMutation/CartMutation'

import { UpdateItemFormModal } from '../UpdateItemFormModal/UpdateItemFormModal'
import { useFulfillment } from '../../FulfillmentProvider/FulfillmentProvider'
import { useOutpostRestaurant } from '../../OutpostProvider/OutpostProvider'

import { AddItem as NestedModifiersAddItem } from '../../NestedModifiers/AddItem/AddItem'
import { FlagOn, FlagOff } from '../../FeatureFlag/FeatureFlag'

export const AddItem = props => (
  <React.Fragment>
    <FlagOn name='oo-v3-nested-modifiers' >
      <NestedModifiersAddItem {...props} />
    </FlagOn >
    <FlagOff name='oo-v3-nested-modifiers'>
      <AddItemInternal {...props} />
    </FlagOff>
  </React.Fragment>
)

const AddItemInternal = ({
  itemGuid,
  itemGroupGuid,
  onClose
}) => {
  const { shortUrl } = useRestaurant()
  const { fulfillmentTime, loading } = useFulfillment()
  const { outpostDeliveryDateTime } = useOutpostRestaurant()
  const dateTime = outpostDeliveryDateTime || fulfillmentTime || undefined

  const [getMenuItemDetails, itemDetailsQuery] = useLazyQuery(MENU_ITEM_DETAILS, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    variables: {
      shortUrl,
      input: { shortUrl, itemGuid, itemGroupGuid, dateTime }
    }
  })

  const [addItemToCart, { error }] = useAddItemToCart({ onCompleted: onClose })

  useEffect(() => {
    if (!loading) getMenuItemDetails()
  }, [getMenuItemDetails, loading])

  const getItemDetails = (data = {}) => {
    const { menuItemDetails } = data
    if (!menuItemDetails) return null

    return {
      ...menuItemDetails,
      usesFractionalQuantity: !!(menuItemDetails.unitOfMeasure && menuItemDetails.unitOfMeasure !== 'NONE'),
      unitOfMeasure: menuItemDetails.unitOfMeasure || '',
      fractionalQuantity: {}
    }
  }

  const getBasePrice = (data = {}) => (data.menuItemDetails && data.menuItemDetails.price) || 0

  return (
    <UpdateItemFormModal
      updateCart={addItemToCart}
      error={error}
      itemDetailsQuery={itemDetailsQuery}
      getItemDetails={getItemDetails}
      getBasePrice={getBasePrice}
      onClose={onClose}
      itemGuid={itemGuid}
      itemGroupGuid={itemGroupGuid}
    />
  )
}

AddItemInternal.propTypes = {
  itemGuid: PropTypes.string.isRequired,
  itemGroupGuid: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
}
